import { render, staticRenderFns } from "./UnitaMobileCaricoMagazzinoDialog.vue?vue&type=template&id=01a77eb2&"
import script from "./UnitaMobileCaricoMagazzinoDialog.vue?vue&type=script&lang=js&"
export * from "./UnitaMobileCaricoMagazzinoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Repository/SprayerManager_WebSite/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VIcon,VTooltip})
